import { render } from "./moreDetailsHeader.vue?vue&type=template&id=4c6f402b&scoped=true"
import script from "./moreDetailsHeader.vue?vue&type=script&lang=js"
export * from "./moreDetailsHeader.vue?vue&type=script&lang=js"

import "./moreDetailsHeader.vue?vue&type=style&index=0&id=4c6f402b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c6f402b"]])

export default __exports__